module.exports = __webpack_public_path__ + "img/icon_win.6dd343d1.png";